Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _airbnbPropTypes = require('airbnb-prop-types');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../themes/withStyles');

var _textlike = require('../utils/propTypes/textlike');

var _textlike2 = _interopRequireDefault(_textlike);

var _idProp = require('../utils/propTypes/idProp');

var _idProp2 = _interopRequireDefault(_idProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _textlike2['default'],
  errorRef: _propTypes2['default'].func,
  id: _idProp2['default'],
  small: _propTypes2['default'].bool
}));

var defaultProps = {
  errorRef: undefined,
  small: false
};

function ErrorMessage(_ref) {
  var children = _ref.children,
      css = _ref.css,
      errorRef = _ref.errorRef,
      id = _ref.id,
      small = _ref.small,
      styles = _ref.styles;

  return _react2['default'].createElement(
    'div',
    _extends({
      id: id,
      'aria-live': 'polite',
      ref: errorRef
    }, css(small ? styles.size_small : styles.size_default, styles.errorMessage)),
    children
  );
}

ErrorMessage.componentCategory = 'Core';
ErrorMessage.displayName = 'ErrorMessage';
ErrorMessage.propTypes = propTypes;
ErrorMessage.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color,
      font = _ref2.font;
  return {
    size_default: Object.assign({}, font.formErrorMessage),

    size_small: Object.assign({}, font.formErrorMessageSmall),

    errorMessage: Object.assign({}, font.book, {
      color: color.inputErrorMessage
    })

  };
})(ErrorMessage);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/ErrorMessage.js
// module id = 408
// module chunks = 923280921217